import XdhTreeSelect from './xdh-tree-select.vue'

XdhTreeSelect.install = function (Vue) {
  Vue.component(XdhTreeSelect.name, XdhTreeSelect)
}
export default XdhTreeSelect



// WEBPACK FOOTER //
// ./src/components/xdhWidgets/xdh-tree-select/index.js